
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { BIconSearch } from "bootstrap-vue";

@Component({
  components: { BIconSearch }
})
export default class CommentModal extends Vue {
  @Prop({ required: true }) item!: any;
  comment: string = '';

  mounted() {
    if (this.item && this.item.comment) {
      this.comment = this.item.comment;
    }
  }

  @Watch('item', { immediate: true, deep: true })
  onItemChange(newItem: any) {
    if (newItem && newItem.comment) {
      this.comment = newItem.comment;
    } else {
      this.comment = '';
    }
  }

  close_comment_modal() {
    this.$bvModal.hide("add_comment_modal");
  }

  onInput(value: string) {
    if (this.comment !== null) {
      this.comment = value.slice(0, 500);
    }
  }

  save_comment_modal() {
    this.$emit('addComment', this.comment);
    this.$bvModal.hide("add_comment_modal");
  }
}
